import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { ButtonSizes, ButtonThemes, LoaderThemes, trueOrUndefined } from '@shared/v2';
import { SdvorLoaderComponent } from '../loader';

/**
 * Компонент `SdvorButtonComponent` используется для выполнения действий при взаимодействии с пользователем.
 * Кнопка является одним из основных элементов пользовательского интерфейса и может быть использована для
 * отправки форм, выполнения команд или навигации.
 *
 * ```ts
 * import { SdvorButtonComponent } from '@sdvor/shared/ui/v2';
 * ```
 */
@Component({
  selector: 'button[sdButton], a[sdButton]',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  imports: [NgTemplateOutlet, SdvorLoaderComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SdvorButtonComponent {
  /** Тема оформления */
  @Input() theme: ButtonThemes = 'primary';
  /** Размер кнопки */
  @Input() size: ButtonSizes;
  /** Растянуть на всю ширину родительского контейнера */
  @Input() fullWidth: boolean;
  /** Состояние загрузки */
  @Input() loading: boolean;
  /** Состояние деактивации */
  @HostBinding('attr.disabled')
  @Input({ transform: trueOrUndefined })
  disabled: boolean;

  get loaderTheme(): LoaderThemes {
    return this.theme === 'secondary' ? 'white' : 'black';
  }

  @HostBinding('class')
  get classNames(): string[] {
    return [
      'button',
      this.theme ? `button-theme-${this.theme}` : '',
      this.loading ? 'state-loading' : '',
      this.fullWidth ? 'full-width' : '',
      this.size ? 'button-size-' + this.size : '',
    ].filter(Boolean);
  }
}
